<template>
  <conditional-section :active="active">
    <list
      :active="active"
      :filter="filter"
      :file-type="this.dataType"
      :database="this.database"
      :fetch="fetch"
      enable-filter
      enable-action
      @act="goTo360View"
      :enable-sort="!disableSort"
      :enable-download="!disableDownload"
      @download="downloadCSV"
      action-text="view"/>
  </conditional-section>
</template>

<script>
  import {fetchInsight} from './utils';
  import ConditionalSection from './ConditionalSection';
  import {E_DOWNLOAD, eventHub} from '../../utils';
  import List from '../List';

  export default {
    name: 'CustomerListSection',

    components: {
      ConditionalSection,
      List
    },

    props: {
      rawFile: Object,
      dataType: String,
      database: String,
      filter: Object | String,
      active: Boolean,
      disableDownload: Boolean,
      disableSort: Boolean
    },

    methods: {
      fetch(params) {
        return fetchInsight('CustomerList', {...this.filter, database: this.database, collection: this.dataType}, params);
      },

      downloadCSV(params) {
        eventHub.$emit(E_DOWNLOAD, {
          filter: {...this.filter, database: this.database, collection: this.dataType},
          params
        });
      },

      goTo360View(record) {
        const userFile = this.$store.getters.getActiveFile(this.dataType);
        console.log("datatype", this.dataType);
        console.log("database", this.database);
        console.log("userfile", userFile);
        console.log("record", record);
        const record_id = record["_id"];
        // this.$emit('360_collection', this.dataType);
        // const idField = userFile.entityMap['customer_no'];
        // const customerID = record[idField];
         this.$router.push(`/360/${this.database}/${this.dataType}/${record_id}`);
        // this.$router.push(`/customer360/${6}`);
      }
    }
  };
</script>
